import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

export const HEADER = {
	backLink: {
		url: RoutesHelper.getMobileAccessibilityDashboardPath()
	}
};
